import type { SiteConfig } from '@/types'

// The site's free web address. Update it if the site moves to a custom domain or the subdomain changes,
// so canonical links, language alternates and share previews keep pointing at the live site.
export const SITE_ORIGIN = 'https://tarmac-sl9-built-for-legends.modulify.website'

export const siteConfig: SiteConfig = {
    name: 'S-Works Tarmac SL9 LTD · Built for Legends',
    description: "Only 199 individually numbered bikes worldwide. Hand-finished Race Red paint, custom SRAM RED AXS and the lowest Time to Finish Specialized has ever measured.",
    url: SITE_ORIGIN,
    ogImage: `${SITE_ORIGIN}/images/og-tarmac-sl9-ltd.jpg`
}
